exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-ee00242c] {\n  padding: 15px 10px;\n}\n.item[data-v-ee00242c]:not(:last-child) {\n    border-bottom: 1px solid #ddd;\n}\n.item__title[data-v-ee00242c] {\n    width: 100%;\n    font-size: 20px;\n    margin-bottom: 15px;\n}\n.item__number[data-v-ee00242c] {\n    color: #3498db;\n}\n.item__info[data-v-ee00242c] {\n    width: 100%;\n}\n.item__info p[data-v-ee00242c] {\n      margin: 6px 0;\n      font-size: 14px;\n}\n.item__info .violations ul[data-v-ee00242c] {\n      margin: 0;\n}\n.item__info .violations ul li[data-v-ee00242c] {\n        padding: 10px 0;\n}\n", ""]);

// exports
